import React from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
//import mtgCompany from '../../../assets/mtg-company.png';
import menusConfig from '../../config/menus';
import nentGroup from '../../../assets/viaplay-logo-light.png';
const mapStateToProps = state => ({
  footer: menusConfig[state.country].footer,
});

@connect(mapStateToProps)
export default class Footer extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      counter: 0,
    };
    this.activeClassName = 'is-active';
    this.doc = null;
    this.onClick = this.onClick.bind(this);
  }

  // React calls this function only in browser environment,
  // so that it is correct place to access document
  componentDidMount() {
    this.doc = document;
    this.activeClassName = null;
  }

  onClick() {
    this.setState(state => ({ counter: state.counter + 1 }));
  }

  render() {
    const currentUrl = this.doc &&
      this.doc.location &&
      this.doc.location.pathname;
    return (
      <footer className="site-footer">
        <div className="sections">
          {this.props.footer.map((section, sectionIndex) => {
            return (
              <section key={sectionIndex}>
                <h5 className="section-title">{section.title}</h5>
                <ul className="section-list">
                  {section.links.map((link, linkIndex) => {
                    return (
                      <li key={linkIndex} className="list-item">
                        {/^https?:\/\//.test(link.url)
                          ? <a href={link.url} target="_blank" rel="nofollow">
                              {link.name}
                            </a>
                          : <Link
                              to={link.url}
                              activeClassName={this.activeClassName}
                              className={
                                currentUrl === link.url ? 'is-active' : ''
                              }
                              onClick={() => window.location =link.url} >
                              {link.name}
                            </Link>}
                      </li>
                    );
                  })}
                </ul>
              </section>
            );
          })}
        </div>

        <div className="brand">
          <img className="brand-nent" src={nentGroup} alt="Viaplay Group" />
        </div>
      </footer>
    );
  }
}

Footer.propTypes = {
  footer: React.PropTypes.array,
};



// WEBPACK FOOTER //
// ./src/component/Sidebar/Footer.jsx